import './components/hn-tabs';
